/*
 * PersonalWidgets Messages
 *
 * This contains all the text for the PersonalWidgets component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  step: {
    id: 'apps.step',
    defaultMessage: 'Бўлим',
  },
  mainFormTitle: {
    id: 'apps.mainFormTitle',
    defaultMessage: 'Ўзбекистон Республикаси Президенти Виртуал Қабулхонаси',
  },
});



// WEBPACK FOOTER //
// ./src/common/messages.js